<mat-form-field appearance="outline" [ngStyle]="{'display': 'flex', 'margin-top': isEditModal ? '8px' : '4px'}" class="full-width">
  <mat-chip-grid #chipGrid >
    <mat-chip-row *ngFor="let color of selectedColors" [removable]="true" (removed)="remove(color)"
    class="mat-standard-chip no-wrap">
      {{color}}
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip-row>
  </mat-chip-grid>
  <input [readonly]="selectedColors.length >= 2"  #colorInput [formControl]="color" [ngStyle]="{'flex': 1, 'height': '32px'}"
    [matChipInputFor]="chipGrid" [matAutocomplete]="autoColor"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    (matChipInputTokenEnd)="add($event)" class="inputField" />
  <mat-autocomplete #autoColor="matAutocomplete" (optionSelected)="selected($event)">
    <mat-option class="input-field"  *ngFor="let color of filteredColors | async" [value]="color">
      {{color}}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>